import { render, staticRenderFns } from "./FuncionalidadeCustomizadaTermoDeUso.vue?vue&type=template&id=71ea6370&scoped=true"
import script from "./FuncionalidadeCustomizadaTermoDeUso.vue?vue&type=script&lang=js"
export * from "./FuncionalidadeCustomizadaTermoDeUso.vue?vue&type=script&lang=js"
import style0 from "./FuncionalidadeCustomizadaTermoDeUso.vue?vue&type=style&index=0&id=71ea6370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea6370",
  null
  
)

export default component.exports